export default __webpack_public_path__ + "static/media/store.2776786b.svg";